import { render } from "./accounts.vue?vue&type=template&id=107b4e2a&scoped=true"
import script from "./accounts.vue?vue&type=script&lang=js"
export * from "./accounts.vue?vue&type=script&lang=js"

import "./accounts.vue?vue&type=style&index=0&id=107b4e2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107b4e2a"]])

export default __exports__